import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, first, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { eventShortUrlQuery, getEvent, getRepeatEvent, repeatEventShortUrlQuery } from '../api/events.queries';
import { IEvent, IRepeatEvent } from 'src/app/shared/interfaces';
import { ApiService, ErrorType } from 'src/app/core/services/api.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';

@Injectable()
export class EventsService extends ApiService {

  constructor(private router: Router,
    private utils: UtilitiesService,
    private analytics: GoogleAnalyticsService,
    private message: MatSnackBar) {
    super();
  }

  public event$(id: string): Observable<IEvent | null> {
    return this.runQuery(getEvent, { id }, 'getEvent', true, true)
      .pipe(
        map((res: any) => {
          if (res) {
            if ((res as ErrorType) === ErrorType.ERROR) {
              this.message.open('There was a problem loading this event!', null, { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
              this.router.navigate([''])
              return null;
            }

            this.utils.addCount(res.id, res.publisherId, res.ownerType, 'views', res.type.toLowerCase() + '-event', 1);
            this.addEventsImpressions([res]);

            return res;
          } else {
            this.router.navigate(['events'], {queryParams: {'not-found': true}})
          }
        }),
        first()
      ) as Observable<IEvent | null>;
  }

  public repeatEvent$(id: string): Observable<IRepeatEvent | null> {
    return this.runQuery(getRepeatEvent, {id} ,'getRepeatEvent', true, true)
      .pipe(
        map((res: any) => {
          if (res) {
            if ((res as ErrorType) === ErrorType.ERROR) {
              this.message.open('There was a problem loading this event!', null, { duration: 2000,  verticalPosition: 'top', horizontalPosition: 'center' });
              this.router.navigate([''])
              return null;
            }

            this.utils.addCount(res.id, res.publisherId, res.ownerType, 'views', res.type.toLowerCase() + '-event', 1);
            this.addEventsImpressions([res]);

            return res;
          } else {
            this.router.navigate(['events'], {queryParams: {'not-found': true}})
          }
        }),
        first()
      ) as Observable<IRepeatEvent | null>;
  }

  public findEventByUsename$(username: string, type?: string): Observable<any | null> {
    return this.runQuery(
      type === 'REPEAT' ? repeatEventShortUrlQuery : eventShortUrlQuery,
      { username, limit: 1 },
      type === 'REPEAT' ? 'repeatEventShortUrlQuery' : 'eventShortUrlQuery',
      true, true
    )
      .pipe(
        map((res: any) => res?.items?.length ? res?.items[0] : null),
        tap((e: IEvent) => {
          this.utils.addCount(e.id, e.publisherId, e.ownerType, 'views', e.type.toLowerCase() + '-event', 1);
          this.addEventsImpressions([e]);
        }),
        first()
      ) as Observable<any | null>;
  }


  public addEventsImpressions(events: (IEvent | IRepeatEvent)[]) {
    events.forEach((e: IEvent | IRepeatEvent) => {
      this.analytics.trackEvent('Event Impression', 'Web App', e.title);
      this.utils.addCount(e.id, e.publisherId, e.ownerType, 'impressions', e.type.toLowerCase() + '-event', 1);
    });
  }


}
